import cssVars from 'css-vars-ponyfill';
import * as clipboard from 'clipboard-polyfill';
import { format, toDate, getUnixTime, parse } from 'date-fns';
import assetsJSON from '../assets/assets.json';

// import { initSentry } from '../../core/helpers';

cssVars({
  rootElement: document,
  shadowDOM: true,
  preserveVars: true,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).golazoAssets = assetsJSON;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).clipboard = clipboard;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).dateFormat = format;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).toDate = toDate;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).getUnixTime = getUnixTime;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).parseDate = parse;

/*=============================================
=            Append() Method Polyfill         =
=============================================*/
// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
((arr) => {
  arr.forEach((item) => {
    if (item.hasOwnProperty('append')) {
      return;
    }
    Object.defineProperty(item, 'append', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function append() {
        // eslint-disable-next-line prefer-rest-params
        const argArr = Array.prototype.slice.call(arguments);
        const docFrag = document.createDocumentFragment();

        argArr.forEach((argItem) => {
          const isNode = argItem instanceof Node;
          docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
        });

        this.appendChild(docFrag);
      },
    });
  });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

/*=============================================
=            Init Sentry                      =
=============================================*/

// initSentry();
